import APIService from './APIService';

export default {
  getTiposImportacoes(empresaId) {
    return APIService.apiCall().get(`importacoes/dados/tipos/get/${empresaId}`);
  }
}